// Only themes are allowed to import scss files.
// eslint-disable-next-line import/no-unassigned-import
import '../../../../../scss/themes/default/default.scss';
import { InternalLink } from '../../../form-elements/Link';
import Image from '../../../Image/Image';

function APSHeader() {
    return (
        <header className='uk-container'>
            <div className='uk-flex uk-flex-center uk-padding'>
                <InternalLink to="/" ariaLabel="Startseite">
                    <Image src="https://techno-images.s3.eu-central-1.amazonaws.com/icons/aps_logo_national.jpg" alt="APS Logo" resizeHeight={50} />
                </InternalLink>
            </div>
            <hr></hr>
        </header>
    )
}

export default APSHeader;
